import {
  FEMaterial,
  VentilatedWallConfigurationState,
  VentilatedWallThermalPerformanceState,
  initialVentilatedWallThermalPerformanceState,
  ThermalPerformanceLayer,
} from "@iko-design-center/shared";

export function updateThermalLayer(
  thermalPerformance: VentilatedWallThermalPerformanceState,
  material: FEMaterial,
  type: string
) {
  const draft: VentilatedWallThermalPerformanceState = { ...thermalPerformance };
  // @ts-ignore
  draft[type] = getThermalPerformanceLayer(material);
  return calculateThermalPerformance(draft);
}

export function getThermalPerformance(
  state: VentilatedWallConfigurationState
): VentilatedWallThermalPerformanceState {
  const thermalPerformance = { ...initialVentilatedWallThermalPerformanceState };

  thermalPerformance.wallType = getThermalPerformanceLayer(
    state.wallType.material!
  );
  thermalPerformance.wallInsulation = getThermalPerformanceLayer(
    state.wallInsulation.material!
  );

  return calculateThermalPerformance(thermalPerformance);
}

function calculateThermalPerformance(
  state: VentilatedWallThermalPerformanceState
): VentilatedWallThermalPerformanceState {
  const draft = { ...state };
  let isComplete = true;

  ["wallType", "wallInsulation"].forEach((layer: string) => {
    // @ts-ignore
    const { thickness, lambda } = draft[layer] as ThermalPerformanceLayer;

    if (thickness && lambda) {
      // @ts-ignore
      draft[layer] = {
        thickness,
        lambda,
        RValue: parseFloat((thickness / 1000 / lambda).toFixed(2)),
      };
    } else {
      isComplete = false;
    }
  });

  if (isComplete) {
    draft.RTValue = parseFloat(
      (
        // RSI +
        draft.wallType.RValue! +
        draft.wallInsulation.RValue! 
        // RSE
      ).toFixed(2)
    );
    draft.UCValue = parseFloat((1 / draft.RTValue).toFixed(2));
  }
  return draft;
}

function getThermalPerformanceLayer(
  material: FEMaterial
): ThermalPerformanceLayer {
  const isVariable =
    material.lambdaThicknessThresholds &&
    material.lambdaThicknessThresholds.length > 0 &&
    material.lambdas.length > 1;

  const thickness = material.thickness;
  let lambda: number;

  if (!isVariable) {
    lambda = material.lambdas[0];
  } else {
    material.lambdaThicknessThresholds!.forEach((threshold, index) => {
      if (thickness > threshold) {
        lambda = material.lambdas[index + 1];
      }
    });
  }

  return {
    thickness,
    lambda: lambda!,
    RValue: null,
  };
}
